module.exports = __webpack_public_path__ + "assets/img/172-6C6D LaVille-v7.938c757a.jpg";